import { render, staticRenderFns } from "./VirtualKeyboard.vue?vue&type=template&id=99e0f438&scoped=true"
import script from "./VirtualKeyboard.vue?vue&type=script&lang=js"
export * from "./VirtualKeyboard.vue?vue&type=script&lang=js"
import style0 from "./VirtualKeyboard.vue?vue&type=style&index=0&id=99e0f438&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e0f438",
  null
  
)

export default component.exports